import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, MapPin, Star, Plus } from 'lucide-react';
import { useState } from 'react';

const categories = ['全部', '景点', '餐厅', '住宿', '购物'];
const tags = ['历史文化', '自然风光', '网红打卡', '亲子友好', '性价比高'];
const sortOptions = ['综合排序', '距离优先', '评分优先', '人气优先'];

const pois = [
  { id: 1, name: '故宫博物院', category: '景点', rating: 4.9, reviews: 12000, price: 60, distance: '1.2km', desc: '中国明清两代的皇家宫殿,世界文化遗产', img: 'forbidden,city' },
  { id: 2, name: '四季民福烤鸭店', category: '餐厅', rating: 4.7, reviews: 3500, price: 180, distance: '3.5km', desc: '正宗北京烤鸭,环境优雅', img: 'beijing,duck' },
  { id: 3, name: '丽江和府洲际度假酒店', category: '住宿', rating: 4.8, reviews: 890, price: 1200, distance: '0.8km', desc: '纳西风格建筑,庭院式度假体验', img: 'lijiang,hotel' },
];

const POIs = () => {
  const navigate = useNavigate();
  const [activeCat, setActiveCat] = useState('全部');
  const [activeTag, setActiveTag] = useState(null);

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="relative mb-6">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-text-tertiary" />
          <Input placeholder="搜索景点、餐厅、住宿..." className="pl-12 h-14 rounded-btn bg-white border-[#E8E4DF] text-text-primary shadow-card" />
        </div>

        <div className="flex gap-2 mb-4 overflow-x-auto pb-1">
          {categories.map((c) => <Badge key={c} onClick={() => setActiveCat(c)} className={`cursor-pointer rounded-full px-4 py-1.5 ${activeCat === c ? 'bg-primary text-white' : 'bg-white text-text-secondary hover:bg-primary-light'}`}>{c}</Badge>)}
        </div><div className="flex gap-2 mb-6 overflow-x-auto pb-1">
          {tags.map((t) => <Badge key={t} onClick={() => setActiveTag(t === activeTag ? null : t)} className={`cursor-pointer rounded-full px-3 py-1 text-xs ${activeTag === t ? 'bg-primary text-white' : 'bg-white text-text-secondary border border-[#E8E4DF]'}`}>{t}</Badge>)}
        </div>

        <div className="flex items-center justify-between mb-4">
          <p className="text-sm text-text-secondary">共 {pois.length} 个结果</p>
          <div className="flex gap-2">
            {sortOptions.map((s) =><button key={s} className="text-xs text-text-tertiary hover:text-primary">{s}</button>)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {pois.map((p) => (
            <Card key={p.id} className="border-0 shadow-card rounded-card bg-white overflow-hidden hover:shadow-hover transition-all cursor-pointer group" onClick={() => navigate(`/poi/${p.id}`)}>
              <div className="flex">
                <div className="w-40 h-40 bg-bg-secondary shrink-0 relative">
                  <img src={`https://picsum.photos/seed/${p.img}/400/400`} alt="" className="w-full h-full mx-auto object-cover" />
                </div>
                <CardContent className="p-4 flex-1">
                  <h3 className="font-semibold text-text-primary mb-1">{p.name}</h3>
                  <div className="flex items-center gap-1 mb-2">
                    <span className="text-primary text-sm">{'★'.repeat(Math.floor(p.rating))}</span>
                    <span className="text-xs text-text-secondary">{p.rating} ({p.reviews})</span>
                  </div>
                  <Badge variant="secondary" className="bg-primary-light text-primary rounded-full text-[10px] mb-2">{p.category}</Badge>
                  <p className="text-xs text-text-tertiary line-clamp-2 mb-2">{p.desc}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-bold text-primary">¥{p.price}<span className="text-xs font-normal text-text-tertiary">/人</span></span>
                    <span className="text-xs text-text-tertiary">{p.distance}</span>
                  </div>
                  <Button size="sm" className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity bg-primary hover:bg-primary-hover text-white rounded-btn h-8 text-xs"><Plus className="w-3 h-3 mr-1" /> 加入行程</Button>
                </CardContent>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default POIs;
